<template>
  <el-dialog v-model="status" :title="title" width="900px" top="3vh" @close="closeEdit">
    <div class="eorderw">
      <div class="goodsw">
        <div class="osearch">
          <el-input size="small" v-model="search.goods_name" @keypress.enter="do_search" placeholder="输入产品名称搜索" style="width: 350px;" />
          <el-button size="small" type="primary" @click="do_search" @keypress.enter="do_search" icon="Search" style="margin-left: 10px;">搜索</el-button>
        </div>
        <div class="goodslsw">
          <div class="glist" v-for="(item,key) in goods.data" :key="key">
            <img class="litpic" :src="item.litpic" />
            <div class="ginfo">
              <div class="gname">{{item.goods_name}}</div>
              <div class="gspecs">
                <div class="specslis" v-for="(p,k) in item.specs" :key="k" @click="changeBuyNum(key,p.specs)">{{p.specs}}{{item.unit}}<span v-if="item.unit!='元'">/{{p.price}}元</span></div>
              </div>
              <div class="acto">
                <el-input-number v-model="item.buy_num" size="small" :step="0.1" :min="0.1" :max="999999" :precision="1" :controls="false" style="width: 80px;" @keypress.enter="addCart(key)" />
                <span class="cunit">{{item.unit}}</span>
                <el-button type="primary" size="small" icon="Plus" color="#94cf39" style="color: #ffffff; margin-left: 15px;" @click="addCart(key)">添加</el-button>
              </div>
            </div>
          </div>
          <el-button v-if="goods.current_page<goods.last_page" icon="DArrowRight" style="display: block; margin: 10px auto 0 auto;" @click="nextPage">{{loading?'加载中...':'加载下一页产品'}}</el-button>
        </div>
      </div>
      <div class="cartw">
        <div class="cgoodsw">
          <div class="cgoodsls" v-for="(item,key) in odetail" :key="key">
            <img class="litpic" :src="item.litpic" />
            <div class="ginfo">
              <div class="gname">{{item.goods_name}}</div>
              <div class="gspecs">{{item.specs}}{{item.unit}}</div>
              <div class="buyprice">
                <div class="price">￥{{item.price}}</div>
                <div class="buynum">
                  <el-icon size="14" style="padding: 5px; margin-right: 5px; color: #333333; vertical-align: top; background: #f5f5f5; cursor: pointer;" @click="changeNun(key,'dec')"><Minus /></el-icon>
                  <el-input-number v-model="item.buy_num" size="small" :step="1" :min="1" :max="99999" :precision="0" :controls="false" style="width: 70px; color: #333333;" @change="calcPrice" />
                  <el-icon size="14" style="padding: 5px; margin-left: 5px; color: #333333; vertical-align: top; background: #f5f5f5; cursor: pointer;" @click="changeNun(key,'add')"><Plus /></el-icon>
                </div>
              </div>
            </div>
            <div class="delout"><el-button size="small" type="danger" icon="Delete" circle style="cursor: pointer;" @click="delCgoods(key)" /></div>
          </div>
        </div>
        <div class="morderact">
          <div class="mintot">订单金额：<span>{{totprice}}元</span></div>
          <el-button class="subobtn" type="primary" color="#ff5907" style="color: #ffffff;" @click="subOrder" :loading="subLoading">确定修改({{Object.keys(odetail).length}}件)</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'editOrder',
  emits:['success'],
  data(){
    return {
      status:false,
      title:'',
      goods:{data:[],total:0,current_page:1,last_page:1},
      search:{
        uid:null,
        page:1,
        goods_name:''
      },
      orderid:null,
      odetail:{},
      totprice:0,
      loading:false,
      subLoading:false
    }
  },
  methods:{
    init(odata){
      var _this=this;
      this.search.uid=odata.uid;
      this.orderid=odata.orderid;
      this.totprice=odata.price_tot;
      this.getGoods();
      this.title='修改订单（客户名称：'+odata.uname+' | 订单号：'+odata.orderid+'）';
      this.status=true;
      this.loading=true;
      this.RequestApi('order_detail.html', {'orderid':odata.orderid}).then(function (res){
        _this.loading=false;
        if(res.status==1){
          _this.odetail=res.odetail;
        }
      })
    },

    init2(uid,uname,orderid,price_tot){
      var _this=this;
      _this.search.uid = uid;
      _this.orderid = orderid;
      _this.totprice= price_tot;
      this.getGoods();
      this.title='修改订单（客户名称：'+uname+' | 订单号：'+orderid+'）';
      this.status=true;
      this.loading=true;
      this.RequestApi('order_detail.html', {'orderid':orderid}).then(function (res){
        _this.loading=false;
        if(res.status==1){
          _this.odetail=res.odetail;
          _this.totprice = Object.values( _this.odetail).reduce(
            (sum, { price, buy_num }) => sum + Number(price) * buy_num,
            0
          );
        }
      })
    },
    /**
     * 获取产品
     */
    getGoods(){
      var _this=this;
      this.RequestApi('ogoods_list.html',this.search).then(function (res){
        if(res.status==1){
          if(res.data.current_page==1){
            _this.goods=res.data;
          }else{
            _this.goods.current_page=res.data.current_page;
            _this.goods.last_page=res.data.last_page;
            _this.goods.data=_this.goods.data.concat(res.data.data);
          }
        }
      })
    },
    /**
     * 确认下单
     */
    subOrder(){
      if(Object.keys(this.odetail).length==0) return this.TipsError('订单不能没有产品');
      var data=[],_this=this;
      for (let k in _this.odetail){
        data.push({
          'gid':_this.odetail[k].gid,
          'spid':_this.odetail[k].spid,
          'buy_num':_this.odetail[k].buy_num
        });
      }
      _this.subLoading=true;
      _this.RequestApi('save_order_edit.html',{'goods':data,'orderid':_this.orderid,'uid':_this.search.uid,'pricetot':_this.totprice}).then(function (res){
        _this.subLoading=false;
        if(res.status==1){
          _this.$emit('success');
          _this.TipSuccess(res.msg);
          _this.closeEdit();
        }else{
          _this.TipsError(res.msg);
        }
      })

    },
    /**
     * 下单(加入到右侧订单内)
     */
    addCart(key){
      if(typeof (this.goods.data[key].buy_num)=='undefined' || this.goods.data[key].buy_num==0){
        return this.TipsError('请输入数量');
      }
      var goods=this.goods.data[key],
          snum=this.goods.data[key].buy_num,
          buy_num=this.goods.data[key].buy_num,
          specs=this.goods.data[key].specs,
          specs2=this.goods.data[key].specs2;
      for(let k=specs.length-1;k>=0;k--){
        if(snum>0){
          snum=snum % specs[k].specs;
        }
      }
      if(snum>0){
        for(let k=0;k<specs.length;k++){
          snum=this.goods.data[key].buy_num % specs[k].specs;
          if(snum==0) break;
        }
      }
      if(snum>0){
        return this.TipsError('购买数量不正确，请重新输入');
      }
      //计算规格添加到购物车
      var cdata= {};
      for(let k=0;k<specs2.length;k++){
        if(buy_num>0 && buy_num>=specs2[k]['specs']){
          let ckey=goods.id+'-'+specs2[k].spid,sbuynum=0;
          if(Object.prototype.hasOwnProperty.call(this.odetail,ckey)){
            sbuynum=parseInt(buy_num/specs2[k]['specs'])+this.odetail[ckey].buy_num;
          }else{
            sbuynum=parseInt(buy_num/specs2[k]['specs']);
          }
          cdata[ckey]={
            'gid':goods.id,
            'goods_name':goods.goods_name,
            'litpic':goods.litpic,
            'spid':specs2[k].spid,
            'buy_num':sbuynum,
            'specs':specs2[k]['specs'],
            'price':specs2[k]['price'],
            'unit':goods.unit
          };
          buy_num=buy_num % specs2[k]['specs'];
        }
      }
      if(buy_num>0){
        cdata=[];
        for(let k=0;k<specs2.length;k++){
          if(this.goods.data[key].buy_num >= specs2[k]['specs']){
            buy_num=this.goods.data[key].buy_num % specs2[k]['specs'];
            if(buy_num==0){
              let ckey=goods.id+'-'+specs2[k].spid,sbuynum=0;
              if(Object.prototype.hasOwnProperty.call(this.odetail,ckey)){
                sbuynum=parseInt(this.goods.data[key].buy_num/specs2[k]['specs'])+this.odetail[ckey].buy_num;
              }else{
                sbuynum=parseInt(this.goods.data[key].buy_num/specs2[k]['specs']);
              }
              cdata[ckey]={
                'gid':goods.id,
                'goods_name':goods.goods_name,
                'litpic':goods.litpic,
                'spid':specs2[k].spid,
                'buy_num':sbuynum,
                'specs':specs2[k]['specs'],
                'price':specs2[k]['price'],
                'unit':goods.unit
              };
              break;
            }
          }
        }
      }
      if(buy_num>0) return this.TipsError('购买数量不正确，请重新输入');
      Object.assign(this.odetail,cdata);
      this.calcPrice();
    },
    /**
     * 点击规格 自动填写到数量输入框
     */
    changeBuyNum(key,specs){
      this.goods.data[key].buy_num=specs;
    },
    /**
     * 加减购买数量
     */
    changeNun(key,type){
      if(type=='add'){//加库存
        this.odetail[key].buy_num+=1;
      }else{//减库存
        if(this.odetail[key].buy_num>1) this.odetail[key].buy_num-=1;
        else this.odetail[key].buy_num=1;
      }
      this.calcPrice();
    },
    /**
     * 计算购物车产品价格
     */
    calcPrice(){
      var totprice=0;
      for (let k in this.odetail){
        let mintot=this.calculation(this.odetail[k].price,this.odetail[k].buy_num,'*',2);
        totprice=this.calculation(totprice,mintot,'+',2);
      }
      this.totprice=totprice;
    },
    /**
     * 删除购物车产品
     */
    delCgoods(key){
      delete this.odetail[key];
      this.calcPrice();
    },
    /**
     * 搜索
     */
    do_search:function (){
      this.search.page=1;
      this.getGoods();
    },
    /**
     * 下一页
     */
    nextPage(){
      if(this.loading) return false;
      this.search.page=this.goods.current_page+1;
      if(this.search.page>this.goods.last_page) return false;
      this.getGoods();
    },
    closeEdit:function (){
      this.title='';
      this.goods={data:[],total:0,current_page:1,last_page:1};
      this.search={page:1,goods_name:''};
      this.odetail={};
      this.totprice=0;
      this.addrkey=0;
      this.address=[{uname:'',uphone:'',address:''}];
      this.odate=this.getTomorrow();
      this.loading=false;
      this.subLoading=false;
      this.status=false;
    }
  }
}
</script>
<style scoped lang="less">
.eorderw{
  overflow: hidden;
  clear: both;
  .goodsw{
    float: left;
    width: 53%;
    height: 700px;
    overflow: hidden;
    .goodslsw{
      height: 674px;
      overflow-y: auto;
      .glist{
        display: flex;
        padding: 8px 0;
        border-bottom: 1px solid #E5E5E5;
        .litpic{
          display: block;
          width: 80px;
          height: 80px;
          flex-shrink: 0;
          border-radius: 4px;
        }
        .ginfo{
          padding-left: 8px;
          flex-grow: 1;
          .gname{
            width: 100%;
            font-size: 14px;
            line-height: 1.2;
            color: #000000;
            padding-bottom: 7px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        .gspecs{
          clear: both;
          overflow: hidden;
          .specslis{
            float: left;
            padding: 0 8px;
            margin-right: 10px;
            margin-bottom: 5px;
            font-size: 12px;
            line-height: 2;
            background-color: #f1f1f1;
            border-radius: 5px;
            user-select: none;
            cursor: pointer;
            &:hover{
              color: #FFFFFF;
              background-color: #ff5907;
            }
          }
        }
        .acto{
          .cunit{
            display: inline-block;
            padding-left: 3px;
          }
        }
      }
    }

  }
  .cartw{
    float: right;
    width: 45%;
    height: 700px;
    padding-left: 2%;
    overflow: hidden;
    border-left: 1px solid #d1d1d1;
    box-sizing: border-box;
    .cgoodsw{
      height: 660px;
      overflow-y: auto;
      .cgoodsls{
        display: flex;
        padding: 8px 0;
        border-bottom: 1px solid #E5E5E5;
        .litpic{
          display: block;
          width: 80px;
          height: 80px;
          flex-shrink: 0;
          border-radius: 4px;
          user-select: none;
        }
        .ginfo{
          padding-left: 8px;
          flex-grow: 1;
          .gname{
            width: 100%;
            font-size: 14px;
            line-height: 1.2;
            color: #000000;
            padding-bottom: 7px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            user-select: none;
          }
          .gspecs{
            font-size: 14px;
            line-height: 2;
            color: #999999;
          }
          .buyprice{
            clear: both;
            overflow: hidden;
            .price{
              float: left;
              width: 90px;
              font-size: 14px;
              line-height: 24px;
              color: #d6352d;
            }
            .buynum{
              float: left;
              padding-left: 10px;
            }
          }
        }
        .delout{
          display: flex;
          width: 32px;
          flex-shrink: 0;
          align-items: center;
        }
      }
    }
    .morderact{
      display: flex;
      padding-top: 8px;
      box-shadow: 0 -3px 3px #f9f9f9;
      .mintot{
        width: 220px;
        flex-grow: 1;
        padding-left: 10px;
        font-size: 14px;
        font-weight: bold;
        line-height: 32px;
        text-align: left;
        vertical-align: top;
        span{
          color: #ff813d;
        }
      }
      .subobtn{
        width: auto;
        padding: 8px;
        white-space: nowrap;
        flex-shrink: 0;
      }
    }
  }
}
</style>
